// extracted by mini-css-extract-plugin
export default {"searchContainer":"MobileGlobalSearch_searchContainer__6JKEz","separator":"MobileGlobalSearch_separator__dd37h"};